<template>
    <div>

         <CustomModal v-if="isModalOpen" ref="customModal" :modalId="modalId" :isOpen="isModalOpen" :showFooter="true" @modalClosed="modalClosed" :isStyle="'max-width:100% !important;'">
            
            <template #header>
                <h5 class="modal-title">{{['create','transfer'].includes(action) ? $t('create_reception') : $t('edit_reception') }}</h5>
                <button type="button" id="close-modal-btn" class="btn-close" data-bs-dismiss="modal" aria-label="Close" @click="modalClosed"></button>
            </template>

            <template #body>
                <div class="modal-body" style="text-align:left">
                        <div class="row">
                            <div class="col-sm-4">
                                <div class="mb-3">
                                    <label for="exampleFormControlInput1"  class="form-label">{{$t('purchase_reference')}}</label>
                                     <auto-complete 
                                        entity="purchases"
                                        emitEvent="emitAutoCompletePurchase"
                                        :defaultValue="data?.reference" 
                                        @emitAutoCompletePurchase="emitAutoCompletePurchase">
                                    </auto-complete>
                                </div>
                            </div>
                            <div class="col-sm-4">
                                <div class="mb-3">
                                    <label for="exampleFormControlInput1"  class="form-label">{{$t('reference')}}</label>
                                    <input v-model="localData.reference" type="string" class="form-control" id="exampleFormControlInput1" placeholder="Reference">
                                </div>
                            </div>
                            <div class="col-sm-4">
                                <div class="mb-3">
                                <label for="exampleFormControlInput1" class="form-label">{{$t('date')}}</label>
                                <input v-model="localData.date" type="date" class="form-control" id="exampleFormControlInput1" placeholder="Reference Date">
                            </div>
                            </div>
                        </div>

                        <hr>
                        <div class="mb-3">
                            <div v-for="(prd,i) in localData.products" :key="i" class="row mb-3">
                                <!-- Product selector: full width on mobile, compact on sm+ -->
                                <div class="col-12 col-xl-5">
                                    <div class="d-flex align-items-center">
                                        <div class="form-check form-switch">
                                            <input
                                                class="form-check-input"
                                                type="checkbox"
                                                id="paymentToggle"
                                                v-model="localData.products[i].custom_product"
                                            >
                                        </div>
                                        <label for="paymentToggle" class="form-label toggle-label me-3">{{localData.products[i].custom_product ? $t('custom_product') : $t('existing_product') }}</label>
                                    </div>

                                <auto-complete  
                                        :uid="i"
                                        v-if="!localData.products[i].custom_product" 
                                        @emitAutoComplete="emitAutoComplete" 
                                        :defaultValue="localData?.products[i]?.product_label" 
                                        entity="inventories"
                                        emitEvent="emitAutoComplete"
                                        :dislaySuggestions="action =='create' ? true : false " 
                                    ></auto-complete>
                                    <product-rich-text-editor
                                        v-if="localData.products[i].custom_product"
                                        v-model="localData.products[i].product_label"
                                        :placeholder="$t('product_label')"
                                    ></product-rich-text-editor>
                                </div>
                                <!-- Qty -->
                                <div class="col-4 col-xl-1"  v-if="localData.products[i].product_id || localData.products[i].custom_product == true">
                                    <label for="exampleFormControlInput1" class="form-label">{{$t('qty')}}</label> 
                                    <select v-if="!localData.products[i].custom_quantity_mode" class="form-select" :value="Number(localData.products[i].quantity)" @change="onQuantityChange(i, $event)">
                                        <option :value="0">0</option>
                                        <option :value="1">1</option>
                                        <option :value="2">2</option>
                                        <option :value="3">3</option>
                                        <option :value="4">4</option>
                                        <option :value="5">5</option>
                                        <option :value="6">6</option>
                                        <option :value="7">7</option>
                                        <option :value="8">8</option>
                                        <option :value="9">9</option>
                                        <option :value="10">10</option>
                                        <option value="custom">Custom</option>
                                    </select>
                                    <div v-else class="input-group">
                                        <input v-model="localData.products[i].quantity" @focus="handleInputFocus(localData.products[i], 'quantity')" @blur="handleInputBlur(localData.products[i], 'quantity', i)" @change="calculatePrices" class="form-control" min="0" type="number" step="any" inputmode="decimal" >
                                        <button class="btn btn-outline-secondary" type="button" @click="switchToSelectMode(i)" style="padding: 0 5px;">
                                            <AppIcon name="bi-list" class="bi bi-list" />
                                        </button>
                                    </div>
                                </div>
                                <!-- Remove button -->
                                <div class="col-12 col-xl-1"  style="margin-top:25px">
                                    <button type="button" class="mb-3 btn line-item-delete-button" :aria-label="$t('delete')" :title="$t('delete')" @click="removeRow(i)"><AppIcon name="bi-trash" class="bi bi-trash" /></button>
                                </div>
                            </div>  
                            
                        </div>

                        <div class="row">
                                <div class="col-sm-9 btn-add-product">
                                    <button type="button" class="mb-3 btn btn-success" @click="addNewRow"><PlusIcon class="me-1 client-lucide-icon" :size="15" :stroke-width="1.75" aria-hidden="true" /> {{$t('product')}}</button>
                                </div>
                                <div class="col-sm-3"></div>
                            </div>

                        <hr>
                        <div class="row">
                             <div class="col-sm-3 mb-2" >
                            <label for="exampleFormControlInput1" class="form-label"><strong>{{$t('supplier')}}</strong></label>
                                    <auto-complete  
                                    @emitAutoCompleteSupplier="emitAutoCompleteSupplier" 
                                    :defaultValue="localData?.supplier?.name"
                                    entity="suppliers" 
                                    v-if="!modalIsLoading"
                                    emitEvent="emitAutoCompleteSupplier"
                                ></auto-complete>
                                <a href="#" class="related-create-link d-block mt-1 small text-decoration-none" @click.prevent="openCreateSupplierModal">
                                    <AppIcon name="bi-plus-circle" class="bi bi-plus-circle me-1" />{{$t('create_new_supplier')}}
                                </a>

                                
                        </div>
                            <div class="col-sm-2">
                                    <label for="exampleFormControlInput1" class="form-label">
                                        {{$t('status')}}
                                    </label>
                                    <select v-model="localData.status" class="form-select" aria-label="Default select example">
                                        <option value="draft">{{$t('draft')}}</option>
                                        <option selected value="pending">{{$t('pending')}}</option>
                                        <option value="received">{{$t('received')}}</option>
                                    </select>
                        </div>
                        </div>
                       

                        <div class="mb-3">
                            <collapsible-notes-field v-model="localData.notes" id="reception-notes" rows="1" />
                        </div>

                        <!-- <div class="mb-3">
                            
                            <span v-if="checkIfValidProduct()" @click="invoiceModalisOpen = true" style="cursor:pointer">
                                <AppIcon name="bi-eye" class="bi bi-eye" style="font-size:12px" />
                                <small>&nbsp;{{$t('preview')}}</small>
                            </span>
                            
                        </div> -->

                    </div>
                                    <div class="alert alert-warning" role="alert" v-if="msgError">
                    {{msgError}}
                </div>
            </template>

            <template #footer>
                <button type="button" class="btn btn-secondary" data-bs-dismiss="modal"><AppIcon name="bi-x-lg" class="bi bi-x-lg me-1" />{{$t('close')}}</button>
                <button v-if="action == 'update'" type="button" class="btn btn-success" @click="updateRow" :disabled="!checkIfValidProduct() || loading">
                    <AppIcon name="bi-pencil" class="bi bi-pencil" style="font-size:12px" />
                    {{$t('edit')}}</button>
                <button v-if="['create','transfer'].includes(action)" type="button" class="btn btn-success" @click="saveRow" :disabled="!checkIfValidProduct() || loading"><AppIcon name="bi-check-circle" class="bi bi-check-circle me-2" />{{$t('create')}}</button>
            </template>

        </CustomModal>

        
        <!-- supplier modal -->
        <add-supplier 
            v-if="createSupplierState"  
            :state="createSupplierState"  
            @createSupplier="createSupplier"/>
        <!-- supplier modal -->

        <!-- invoice modal -->
        <invoice-template-modal 
            v-if="invoiceModalisOpen" 
            @modalClosed="invoiceModalisOpen = false" 
            modalId="invoice-reception-modal-22" 
            :isModalOpen="invoiceModalisOpen"  
            :data="data" 
            type="reception">
        </invoice-template-modal>
        <!-- invoice modal -->

    </div>
   
    
    
</template>

<script>
import CustomModal from '../CustomModal.vue'
import helper from '../../helper'
import AutoComplete from '../autocomplete/AutoComplete'
import AddSupplier from '../AddSupplier.vue'
import InvoiceTemplateModal from '../invoiceLayout/InvoiceTemplateModal.vue'
import ProductRichTextEditor from '../common/ProductRichTextEditor.vue'
import moment from 'moment'
export default {
  name: 'AddEditReceptionModal',
  props : {
        action: {
            type: String,
            required: true
        },
        data: {
            default: false
        },
        isModalOpen: {
            type: Boolean,
            default: false
        },
        modalId : {
            type : String,
            default : 'exampleModal'
        },
        from : {
            type : String,
        }
    },
  components : {
    CustomModal,
    AutoComplete,
    AddSupplier,
    InvoiceTemplateModal,
    ProductRichTextEditor
  },
  data(){
    return {
        loading : false,
        invoiceModalStatus : false,
        invoiceModalisOpen :false,
        createSupplierState : false,
        hideSupplier : false,
        localData: JSON.parse(JSON.stringify(this.data)),
        modalIsLoading : false,
        msgError : null
    }
  },
   mounted(){
    if(this.isDetailClient && this.isDetailClient == true){
        this.hideSupplier = true
    }

  },
  
  computed : {
    business(){ return this.$store.getters.BUSINESS},
    total(){ return this.localData.products.length ? this.localData.products.map(o => o.total).reduce((a, c) => { return a + c }) : 0},
    sub_total(){ return this.localData.products.length ? this.localData.products.map(o => o.sub_total).reduce((a, c) => { return a + c }) : 0},
  },
  methods : {
    async saveRow(){
        try{
            this.loading = true
            this.sanitizeCustomProductLabels()

            //format products
            this.localData.products = helper.formatProducts(this.localData.products)
            if(!this.localData.supplier_id && this.localData.supplier && this.localData.supplier.id ){
                this.localData.supplier_id = this.localData.supplier.id
            }
            
            
            for(let i = 0 ; i < this.localData.products.length ; i++){
                if(this.localData.products[i].quantity == 0){
                    this.msgError += `${this.$t('product')}: [${helper.richTextToPlainText(this.localData.products[i].product_label)}] ${this.$t('quantity')} :[${this.localData.products[i].quantity}] \n`
                }
            }

            if(!this.localData.products.length){
                this.msgError = `No Product Found`
            }

            if(this.msgError !== null) {
                this.loading = false
                return
            }

            // Update the existing draft instead of creating a new one
            const response = await helper.customPatch(`${process.env.VUE_APP_API}/receptions/${this.localData.id}`,{...this.localData },{showToast:true})
            this.clearForm()
            this.loading = false
            this.modalClosed()
            this.$router.push({path : `/receptions/${response.data.id}` })
        }catch(error){
            this.loading = false
        }
    },
    async updateRow(){
        try{
            this.loading = true
            this.sanitizeCustomProductLabels()

            //format products
            this.localData.products = helper.formatProducts(this.localData.products)
            if(!this.localData.supplier_id && this.localData.supplier && this.localData.supplier.id ){
                this.localData.supplier_id = this.localData.supplier.id
            }

            
            for(let i = 0 ; i < this.localData.products.length ; i++){
                if(this.localData.products[i].quantity == 0){
                    this.msgError += `${this.$t('product')}: [${helper.richTextToPlainText(this.localData.products[i].product_label)}] ${this.$t('quantity')} :[${this.localData.products[i].quantity}] \n`
                }
            }

            if(!this.localData.products.length){
                this.msgError = `No Product Found`
            }

            if(this.msgError !== null) {
                this.loading = false
                return
            }
            await helper.customPatch(`${process.env.VUE_APP_API}/receptions/${this.localData.id}`,{...this.localData })
            this.loading = false
            this.clearForm()
            this.modalClosed()
            this.$emit('refresh',true)
        }catch(error){
            this.loading = false
        }
    },
    clearForm(){
        this.localData = {
            id : null,
            reference : '',
            client_id : null,
            client : {},
            date : '',
            total : 0,
            products : []
        }

    },
    addNewRow(){
        this.localData.products.push({
            id : null,
            label : '',
            quantity : 0,
            price : 0,
            discount : 0,
            vat :  this.business.vat,
            total : 0,
            sub_total : 0,
            custom_product : false,
            custom_quantity_mode : false
        })
    },
    removeRow(i){
       this.localData.products.splice(i, 1);
    },
    onQuantityChange(index, event) {
        const val = event.target.value;
        if (val === 'custom') {
            this.localData.products[index].custom_quantity_mode = true;
        } else {
            this.localData.products[index].custom_quantity_mode = false;
            this.localData.products[index].quantity = Number(val);
            this.calculatePrices();
        }
    },
    switchToSelectMode(index) {
        this.localData.products[index].custom_quantity_mode = false;
        this.localData.products[index].quantity = 0;
        this.calculatePrices();
    },
    handleInputFocus(row, field){
        if(row[field] == 0){
            row[field] = ''
        }
    },
    handleInputBlur(row, field){
        if(row[field] === '' || row[field] === null || row[field] === undefined){
            row[field] = 0
            if(['quantity'].includes(field)){
                this.calculatePrices()
            }
        }
    },
    calculatePrices(){
        this.msgError = null
        this.$forceUpdate();
        for(let i = 0 ; i < this.localData.products.length ; i++){
            this.localData.products[i].total = parseFloat(this.localData.products[i].price) * parseFloat(this.localData.products[i].quantity)
            this.localData.products[i].sub_total = Math.round(parseFloat(this.localData.products[i].total))
            if(this.localData.products[i].vat > 0){
                this.localData.products[i].total += parseFloat((parseFloat(this.localData.products[i].total) * parseFloat(this.localData.products[i].vat/ 100)).toFixed(2))
                this.localData.products[i].total = Math.round(this.localData.products[i].total)
            }
        }
        this.localData.total = this.localData.products && this.localData.products.length ? this.localData.products.map(o => o.total).reduce((a, c) => { return a + c }) : 0;
    },
    parseTTctoHt(index,price){
        if(price && price > 0){
           this.localData.products[index].price = ((price / this.localData.products[index].quantity) / 1.2).toFixed(2)
           this.localData.products[index].sub_total = parseFloat(this.localData.products[index].price) * parseFloat(this.localData.products[index].quantity)
        }
    },
    emitAutoComplete(data){
        if(!this.localData.products.length || !this.localData.products.find(product => product.product_id == data.result.product.id)){
            this.localData.products[data.index] = {
                ...{
                inventory_id : data.result.id,
                product_id : data.result.product.id,
                label : data.result.product.label,
                product_label : data.result.product.label,
                quantity : 0,
                maxQty : data.result.quantity,
                price : data.result.price,
                unity : data.result.unity,
                purchase_price : data.result.purchase_price ? data.result.purchase_price : 0,
                vat :  data.result.vat ? data.result.vat : this.business.vat,
                total : data.result.total ? data.result.total : 0,
                sub_total : data.result.sub_total ? data.result.sub_total : 0,
                custom_product : false,
                custom_quantity_mode : false
            }}
            this.localData.products = [...this.localData.products]
        }
    },
    emitAutoCompleteSupplier(data){
        this.localData.supplier_id = data.result.id
        this.localData.supplier = data.result
    },
    openCreateSupplierModal(){
        this.createSupplierState = !this.createSupplierState
    },
    createSupplier(data){
        if(data.supplier){
            this.localData.supplier_id = data.supplier.id
            this.localData.supplier = data.supplier
        }
        if(data && data.state != undefined){
            this.createSupplierState = data.state
            this.modalIsLoading = true
            setTimeout(() => { this.modalIsLoading = false })
        }
    },
    emitAutoCompletePurchase(data){
        this.modalIsLoading = true
        this.localData.products = data.result.products
        this.localData.purchase_id = data.result.id
        this.localData.supplier_id = data.result.supplier_id
        this.localData.supplier = data.result.supplier
        this.calculatePrices()
        setTimeout(() => { this.modalIsLoading = false })
    },
    checkIfValidProduct(){
        return this.localData.products.length > 0 && this.localData.products.every(product => (
            product.product_id != null
            || (product.custom_product === true && helper.richTextToPlainText(product.product_label).trim().length > 0)
        ))
    },
    sanitizeCustomProductLabels(){
        this.localData.products.forEach(product => {
            if (product.custom_product) {
                product.product_label = helper.sanitizeRichText(product.product_label)
            }
        })
    },
    modalClosed(){
        this.isModalOpen = false 
        if(document.getElementById('close-modal-btn')){
            document.getElementById('close-modal-btn').click()
        }
        this.$emit('modalClosed', true)
    },
    //helper functions
    formatDate(date,locale) { return helper.formatDate(date,locale) },
    formatMoney(number) { return helper.formatMoney(number);},
    formatReference(number,id) { return helper.formatReference(number,id);}
  },
  async created(){
    if(this.localData.date) {
        this.localData.date = moment(this.localData.date).format('YYYY-MM-DD')
    }else{
        this.localData.date = moment().format('YYYY-MM-DD')
    }

    if(this.localData.products.length){
        for(let i = 0 ; i < this.localData.products.length ; i++){
            const q = Number(this.localData.products[i].quantity);
            this.localData.products[i].custom_quantity_mode = ![0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10].includes(q);
        }
    }

    // When creating, immediately create a draft on the server and keep its id/reference
    if(['create','transfer'].includes(this.action)){
        const { data } = await helper.customPost(`${process.env.VUE_APP_API}/receptions/draft`,{})
        this.localData.id = data.id
        this.localData.reference = data.reference
        if(data.date){
            this.localData.date = moment(data.date).format('YYYY-MM-DD')
        }
    }
  }
}
</script>

<style scoped>
    .table-borderless>:not(caption)>*>*{
        padding: 5px !important
    }
</style>
